import { render } from "./FertilitiJantan.vue?vue&type=template&id=26ac73a6"
import script from "./FertilitiJantan.vue?vue&type=script&lang=js"
export * from "./FertilitiJantan.vue?vue&type=script&lang=js"

import "./FertilitiJantan.vue?vue&type=style&index=0&id=26ac73a6&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__